import "@babel/polyfill";

import Vue from 'vue'
import VueRouter from 'vue-router'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueRouter);
Vue.use(Vuetify, {
    theme: {
        primary: "#4CAF50",
        secondary: "#81C784",
        accent: "#E91E63",
        error: "#f44336",
        warning: "#ffeb3b",
        info: "#03A9F4",
        success: "#4caf50"
    }
});

import RegionView from './components/Region.vue'
import NewsView from './components/News.vue'

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', component: NewsView },
        { path: '/tournament/:region/:year/:period', component: RegionView }
    ]
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')